/** The product catalogue screen. */
export default {
  'products.count': { one: '{count} product', other: '{count} products' },
  'products.hint': 'Search by name, SKU or barcode',
  'products.search': 'Search products…',
  'products.searchLabel': 'Search products',
  'products.product': 'Product',
  'products.barcode': 'Barcode',
  'products.category': 'Category',
  'products.selling': 'Selling',
  'products.cost': 'Cost',
  'products.stock': 'Stock',
  'products.aboveMrp': 'Selling above MRP — not allowed for MRP-inclusive pricing',
  'products.add': 'Add product',
  'products.editTitle': 'Edit product',
  'products.newTitle': 'New product',
  'products.save': 'Save product',
  'products.saving': 'Saving…',
  'products.saved': 'Product saved',
  'products.name': 'Name',
  'products.localName': 'Local name',
  'products.sku': 'SKU',
  'products.price': 'Selling price (₹)',
  'products.mrp': 'MRP (₹)',
  'products.gst': 'GST rate',
  'products.unit': 'Unit',
  'products.hsn': 'HSN code',
  'products.active': 'On sale',
  'products.required': 'A name, a GST rate and a valid selling price are required.',
  'products.priceInvalid': 'Enter a valid price (rupees, up to two decimals).',
  'products.priceHistory': 'Price history',
  'products.historyEmpty': 'No price changes yet.',
  'products.historyRow': '₹{old} → ₹{new} · {when}',
  'error.BARCODE_TAKEN': 'Another product already carries this barcode.',
  'error.SKU_TAKEN': 'Another product already uses this SKU.',
  'error.TAX_RATE_NOT_FOUND': 'That GST slab could not be found. Refresh and pick another.',
} as const;
